'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CustomerRoutes;

var _customersTpl = require('./customers.tpl.html');

var _customersTpl2 = _interopRequireDefault(_customersTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
function CustomerRoutes($stateProvider) {

    $stateProvider.state('home.customers', {
        url: '/customers',
        params: { 'topIndex': 0 },
        module: 'private',
        auth: ['TENANT_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _customersTpl2.default,
                controllerAs: 'vm',
                controller: 'CustomerController'
            }
        },
        data: {
            searchEnabled: true,
            pageTitle: 'customer.customers'
        },
        ncyBreadcrumb: {
            label: '{"icon": "supervisor_account", "label": "customer.customers"}'
        }
    });
} /*
   * Copyright © 2016-2018 The Thingsboard Authors
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
/* eslint-disable import/no-unresolved, import/default */


// WEBPACK FOOTER //
// ./src/app/customer/customer.routes.js